import forOwn from 'lodash/forOwn';
import keys from 'lodash/keys';
import { isArray, isString} from 'lodash';
import isValidState from 'is-valid-state';

const US_TERRITORIES_STATE_CODES = ['AS', 'GU', 'MH', 'FM', 'MP', 'PW', 'PR', 'VI'];
const emailRx = /^[-!#$%&'*+/0-9=?A-Z^_a-z{|}~](\.?[-!#$%&'*+/0-9=?A-Z^_a-z`{|}~])*@[a-zA-Z0-9](-?\.?[a-zA-Z0-9])*\.[a-zA-Z](-?[a-zA-Z0-9])+$/;
const passwordRx = /^(?!.* )(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[.#?!@$%^&*-]).{10,}$/;
const lettersRx = /^[A-Za-z\s'-]+$/;
const numericRx = /^[0-9]+$/;
const nameRx = /^[A-Za-z\s'`-]{0,25}$/;
const specialCharsRx = /^$|^[^<>~*%:\\\\()=+"^]+$/;
const specialCharsPermissiveRx = /^$|^[^<>~%=+^]+$/;
const roomNameRx = /^[A-Za-z0-9\s.,'#_-]{0,50}$/;
const clockRx = /^([0-9]{1,2})(:?[0-9]*)$/;
const alphanumericRx = /^[A-Za-z\d ]+$/;
const rosterSearchRx = /^[A-Za-z0-9\s-]+$/;

const splitRule = (rule) => {
  let r = rule;
  let c;

  if (r.indexOf('-') > -1) {
    [r, c] = r.split('-');
  }

  return {
    rule: r,
    constrain: c,
  };
};


export default class ValidationService {
  static validEmail(email) {
    if (!email) {
      return true;
    }

    const valid = emailRx.test(email);
    if (!valid) {
      return false;
    }
    // Further checking of some things regex can't handle
    const parts = email.split('@');
    if (parts[0].length > 64) {
      return false;
    }

    const domainParts = parts[1].split('.');
    if (domainParts.some(part => part.length > 63)) {
      return false;
    }

    return true;
  }

  static validPassword(password) {
    if (!password) {
      return false;
    }

    return passwordRx.test(password);
  }

  static validState(state) {
    if (!state) {
      return false;
    }

    return isValidState(state) || US_TERRITORIES_STATE_CODES.indexOf(state) !== -1;
  }

  static letters(name) {
    if (!name) {
      return true;
    }

    return lettersRx.test(name);
  }

  static numeric(number) {
    if (!number) {
      return true;
    }

    return numericRx.test(number);
  }

  static clock(number) {
    if (!number) {
      return true;
    }

    return clockRx.test(number);
  }

  static name(value) {
    if (!value) {
      return true;
    }

    return nameRx.test(value);
  }

  static specialChars(value) {
    if (!value) {
      return true;
    }

    return specialCharsRx.test(value);
  }

  static specialCharsPermissive(value) {
    if (!value) {
      return true;
    }
    return specialCharsPermissiveRx.test(value);
  }

  static roomName(value) {
    if (!value) {
      return true;
    }

    return roomNameRx.test(value);
  }

  static alphanumeric(value) {
    if (!value) {
      return true;
    }

    return alphanumericRx.test(value);
  }

  static rosterSearchValidation(value) {
    if (!value) {
      return true;
    }

    return rosterSearchRx.test(value);
  }

  static lt(value, maxLength) {
    return value.toString().length < +maxLength;
  }

  static gt(value, minLength) {
    if (value.toString().length === 0) {
      return true;
    }
    return value.toString().length > +minLength;
  }

  static len(value, len) {
    return value.toString().length === +len;
  }

  static required(value) {
    if (isArray(value)) {
      return !!value.length;
    }
    if (isString(value)) {
      value = value.trim();
    }
    return value && value !== null && value !== undefined && value !== '' && value !== false;
  }

  static requiredOrZero(value) {
    return value !== null && value !== undefined && value !== '' && value !== false;
  }

  static startsWithOne(value) {

    return Number(value[0]) >= 1
  }

  static mapErrorStrings(errors, errorStrings) {
    const err = errors;

    forOwn(err, (value, field) => {
      // map errors to an array for each field
      err[field] = keys(value).map(key => errorStrings[field][key]);
    });
    return err;
  }

  static validate(fields, rules, errorStrings) {
    const vFields = { ...fields };
    const self = this;
    let errors = {};
    forOwn(vFields, (value, field) => {
      if (!rules[field]) {
        return;
      }

      rules[field].some((fieldRule) => {
        const { rule, constrain } = splitRule(fieldRule);
        const isInvalid = self[rule] && !self[rule](value, constrain);

        if (isInvalid) {
          errors[field] = {};
          errors[field][rule] = isInvalid;
        }
        return isInvalid;
      });
    });

    if (errorStrings) {
      errors = this.mapErrorStrings(errors, errorStrings);
    }

    return errors;
  }
}
